export enum Currency {
  US_DOLLAR = "USD", // Доллар США
  UZBEK_SOM = "TJS", // Узбекский сум
}
